module.exports = __webpack_public_path__ + "assets/b394983cef4b9b4f23539b0084535050.svg";